// /* eslint-disable default-param-last */
import { routerReducer as routing } from 'react-router-redux'
import { combineReducers } from 'redux'
import { Action } from 'redux-actions'
// import { createResponsiveStateReducer } from 'redux-responsive'

import { reducer as mapVisualizer } from 'mapVisualizer'
import { reducer as leaderboard } from 'leaderboards'
import { reducer as donorRoll } from 'donorRoll'
import { reducer as affiliation } from 'affiliation'
import { reducer as dashboard } from 'dashboards'
import { reducer as ambassador } from 'ambassador'
import { reducer as viewchallenge } from 'viewchallenge'
import { api } from 'api/reducer'
import * as t from './types'
import { DEFAULT_API_POLLING_TIME_INTERVAL } from '../constants'
const initialConfigState: RootState['config'] = {
  controlId: 0,
  scoreboardTypeId: 0,
}
export const config = (state = initialConfigState, action: Action<number>) => {

  switch (action.type) {
    case t.ASSIGN_SCOREBOARD_TYPE_ID: {
      const newState = {
        ...state,
        scoreboardTypeId: action.payload
      }
      return newState
    }
    case t.ASSIGN_CONTROL_ID: {
      return {
        ...state,
        controlId: action.payload,
      };
    }
    default:
      return state
  }
}

const initialApiPollingState: RootState["apiPolling"] = {
  timeInterval: DEFAULT_API_POLLING_TIME_INTERVAL,
};

export const apiPolling = (state = initialApiPollingState, action: Action<number>) => {
  switch (action.type) {
    case t.ASSIGN_API_POLLING_TIME_INTERVAL: {
      const updatedState = {
        ...state,
        timeInterval: action.payload,
      };
      return updatedState;
    }
    default:
      return state;
  }
}
const browser = "";
const reducer = combineReducers<any>({
  routing,
  mapVisualizer,
  leaderboard,
  donorRoll,
  affiliation,
  dashboard,
  ambassador,
  viewchallenge,
  config,
  api,
  browser,
  apiPolling,
})

export { reducer }